module.exports = __webpack_public_path__ + "static/target-1942b8c6b8b1842c819d2f2e2a8929df.gif";